<template>
    <div>
        <div id="map" style="width: 100%; height: 500px"></div>
    </div>
</template>

<script>
import 'mapbox-gl/dist/mapbox-gl.css';
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
import MapBox from '../mixins/MapBox/Map';

export default {
    mixins: [MapBox],
    props: {
        layerResource: {
            type: Object,
            default: function() {
                return null;
            }
        },
        adminLang: {
            type: String,
            default: '',
        },
    },
    methods: {
        loadImageries() {
            if (this.layerResource.imageries.length == 0) return;
            var self = this;

            this.layerResource.imageries.forEach((imagery) => {
                const sourceId = 'imagery-source-' + imagery.id;
                const layerId = 'imagery-layer-' + imagery.id;

                if (!self.mySmartMap.getSource(sourceId)) {
                    self.mySmartMap.addSource(sourceId, {
                        type: 'image',
                        url: imagery.image_url,
                        coordinates: imagery.coordinates
                    });
                }
                if (!self.mySmartMap.getLayer(layerId)) {
                    self.mySmartMap.addLayer({
                        id: layerId,
                        type: 'raster',
                        source: sourceId,
                        paint: {
                            'raster-opacity': 0.9,
                            'raster-fade-duration': 0
                        }
                    });
                } else {
                    self.mySmartMap.setLayoutProperty(layerId, 'visibility', 'visible');
                }
            });
        }
    },
    mounted() {
        const bounds = this.mySmartMap.getBounds();
        this.mySmartMap.setMaxBounds(bounds);
        if (this.mapData && this.markerSource && this.markerSource[0]) {
            this.mySmartMap.setMinZoom(this.mapData.min_zoom);
            this.mySmartMap.setZoom(this.mapData.zoom_level);
        }
        var self = this;
        this.mySmartMap.on('load', function () {
            if (self.adminLang === 'ja') {
                self.switchLanguage(self.adminLang)
            }
            if (!self.layerResource) return;
            self.loadImageries();
            self.mySmartMap.once('render', function() {
                self.handleMarker();
            });
        });
    },
    watch: {
        layerResource(newVal, oldVal) {
            var self = this;
            if (oldVal.imageries.length > 0) {
                oldVal.imageries.forEach((img) => {
                    self.mySmartMap.setLayoutProperty('imagery-layer-' + img.id, 'visibility', 'none');
                });
            }
            this.loadImageries();
        }
    }
};
</script>

<style>
</style>